import React from "react";
import { InquiryForm, type FormField } from "../components/InquiryForm";
import { investorHighlights, unitEconomics, useOfFunds, roadmap, raise, costNote, brandAdvantage } from "../data/investorData";
const fields: FormField[] = [{
  name: "name",
  label: "Full name",
  required: true,
  half: true
}, {
  name: "email",
  label: "Email",
  type: "email",
  required: true,
  half: true
}, {
  name: "amount",
  label: "Interested amount",
  type: "select",
  options: ["$5k – $10k", "$10k – $25k", "$25k – $50k", "$50k+"],
  half: true
}, {
  name: "phone",
  label: "Phone",
  type: "tel",
  half: true
}, {
  name: "note",
  label: "Questions",
  type: "textarea"
}];
export function Investors() {
  return <div className="mx-auto max-w-6xl px-5 py-12 md:py-16" data-id="element-172" data-mp="1rgauplc3uppi">
      <header className="grid gap-10 md:grid-cols-[1.3fr_1fr] md:items-end" data-id="element-173" data-mp="1rehp89d8abj3">
        <div data-id="element-174" data-mp="2f5dfh221cyo8">
          <h1 className="font-display text-5xl font-bold uppercase leading-none tracking-tight text-ink md:text-6xl" data-id="element-175" data-mp="2f4u7ad26tone">Back the first production run</h1>
          <p className="mt-4 max-w-xl text-lg text-muted" data-id="element-176" data-mp="2nye8qutomu50">
            The factory already has the mold and has sent a quote. The money goes to the first series, packaging, and getting it onto shop counters, not R&amp;D. We run one series at a time, and each series funds the next.
          </p>
        </div>
        <div className="rounded-2xl bg-ink p-6 text-paper" data-id="element-177" data-mp="2sxqrb3ditf1s">
          <p className="text-sm text-paper/60" data-id="element-178" data-mp="2sw61ts62cmas">Raising</p>
          <p className="font-display text-4xl tracking-wide" data-id="element-179" data-mp="36o44pl96llyi">{raise.amount}</p>
          <p className="mt-3 text-sm text-paper/80" data-id="element-180" data-mp="31r3y998f6h6v">{raise.instrument} · {raise.minimum} minimum</p>
        </div>
      </header>

      <dl className="mt-12 grid grid-cols-2 gap-y-8 border-y border-line py-8 md:grid-cols-4" data-id="element-181" data-mp="3gn32g8serx6q">
        {investorHighlights.map(h => <div key={h.label} data-id="element-182" data-mp="1m9k9zdd8j4sa">
            <dt className="text-sm text-muted" data-id="element-183" data-mp="1m8ses3njv92j">{h.label}</dt>
            <dd className="mt-1 text-2xl font-semibold text-ink" data-id="element-184" data-mp="1hah1tk1ykig3">{h.value}</dd>
          </div>)}
      </dl>

      <section aria-labelledby="brand-h" className="mt-16" data-id="element-185" data-mp="26yw8w9ksie1o">
        <h2 id="brand-h" className="text-xl font-semibold text-ink" data-id="element-186" data-mp="270fsa91qt57o">Why launch under SKLUNX</h2>
        <dl className="mt-6 grid gap-8 md:grid-cols-3" data-id="element-187" data-mp="2b0hsedrtxqku">
          {brandAdvantage.map(b => <div key={b.title} data-id="element-188" data-mp="2fxztjhzlv1ia">
              <dt className="font-semibold text-ink" data-id="element-189" data-mp="2kydyus9tnxcm">{b.title}</dt>
              <dd className="mt-1 text-sm text-muted" data-id="element-190" data-mp="2kzp6x4aavr9j">{b.text}</dd>
            </div>)}
        </dl>
      </section>

      <div className="mt-16 grid gap-16 lg:grid-cols-2" data-id="element-191" data-mp="2tz2hy1e2onwd">
        <section aria-labelledby="ue-h" data-id="element-192" data-mp="2txizq58uw2ry">
          <h2 id="ue-h" className="text-xl font-semibold text-ink" data-id="element-193" data-mp="2ypsk75r7camu">Unit economics by channel</h2>
          <table className="mt-6 w-full text-left text-sm" data-id="element-194" data-mp="33ovrkwunmsxz">
            <thead className="border-b border-ink text-muted" data-id="element-195" data-mp="33odophdhlgh3">
              <tr data-id="element-196" data-mp="38oi2v0qx9z45">
                <th className="py-3 font-medium" data-id="element-197" data-mp="38p9pvn6geoit">Channel</th>
                <th className="py-3 text-right font-medium" data-id="element-198" data-mp="3dmtenh0s2jp0">Price</th>
                <th className="py-3 text-right font-medium" data-id="element-199" data-mp="3dkytc1llgpke">Cost</th>
                <th className="py-3 text-right font-medium" data-id="element-200" data-mp="120hi8pg0waat">Margin</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-201" data-mp="wz1w0u23zxqu">
              {unitEconomics.map(u => <tr key={u.channel} data-id="element-202" data-mp="s220ve6ssfei">
                  <td className="py-4 text-ink" data-id="element-203" data-mp="n2gpg4afyekw">{u.channel}</td>
                  <td className="py-4 text-right tabular-nums text-ink" data-id="element-204" data-mp="n408g2nhf3qd">${u.price.toFixed(2)}</td>
                  <td className="py-4 text-right tabular-nums text-muted" data-id="element-205" data-mp="1kpo58onuno2f">${u.cost.toFixed(2)}</td>
                  <td className="py-4 text-right font-semibold tabular-nums text-ink" data-id="element-206" data-mp="1frmjtx2ybcns">{Math.round((u.price - u.cost) / u.price * 100)}%</td>
                </tr>)}
            </tbody>
          </table>
          <p className="mt-3 text-sm text-muted" data-id="element-207" data-mp="1611g5v8f7hy0">{costNote}</p>
        </section>

        <section aria-labelledby="funds-h" data-id="element-208" data-mp="23i9uur85yiek">
          <h2 id="funds-h" className="text-xl font-semibold text-ink" data-id="element-209" data-mp="1ypywvtwzh6on">Use of funds</h2>
          <ul className="mt-6 flex flex-col gap-4" data-id="element-210" data-mp="1yo5l607ijw9s">
            {useOfFunds.map(f => <li key={f.label} data-id="element-211" data-mp="1ja1ugtzrivyu">
                <div className="flex justify-between text-sm" data-id="element-212" data-mp="1o7lb20jxnkty">
                  <span className="text-ink" data-id="element-213" data-mp="1o4z70aw93ngh">{f.label}</span>
                  <span className="tabular-nums text-muted" data-id="element-214" data-mp="19b2yoc03iut9">{f.pct}%</span>
                </div>
                <div className="mt-1.5 h-2 rounded-full bg-mist" data-id="element-215" data-mp="1e9xdz3yuu18m">
                  <div className="h-full rounded-full bg-ink" style={{
                width: `${f.pct}%`
              }} data-id="element-216" data-mp="21yqg5i62l5bo" />
                </div>
              </li>)}
          </ul>
        </section>
      </div>

      <section aria-labelledby="road-h" className="mt-16" data-id="element-217" data-mp="1s8nbulti04y1">
        <h2 id="road-h" className="text-xl font-semibold text-ink" data-id="element-218" data-mp="1s842hthwyovm">Launch plan</h2>
        <ol className="mt-6 grid gap-8 border-t border-ink pt-6 md:grid-cols-4" data-id="element-219" data-mp="1x6feoavolbh0">
          {roadmap.map(r => <li key={r.title} data-id="element-220" data-mp="2kvrj6xg2cvcz">
              <p className="text-sm font-medium text-amber" data-id="element-221" data-mp="2po16s6tphjc3">{r.when}</p>
              <h3 className="mt-1 font-semibold text-ink" data-id="element-222" data-mp="2ppccwdamj36d">{r.title}</h3>
              <p className="mt-1 text-sm text-muted" data-id="element-223" data-mp="e80s2jpf3vu3">{r.text}</p>
            </li>)}
        </ol>
      </section>

      <section aria-labelledby="deck-h" className="mt-16 grid gap-10 rounded-3xl bg-white p-6 md:grid-cols-[1fr_1.4fr] md:p-10" data-id="element-224" data-mp="99pf403tt57n">
        <div data-id="element-225" data-mp="izsi8t4nvzjp">
          <h2 id="deck-h" className="text-2xl font-semibold text-ink" data-id="element-226" data-mp="j00xgro9bgy2">Request the investor deck</h2>
          <p className="mt-3 text-muted" data-id="element-227" data-mp="3rfcabotljbx6">You'll get the full deck, factory quote, and sample photos. Investing carries risk, and this page is not an offer of securities.</p>
        </div>
        <InquiryForm fields={fields} submitLabel="Request the deck" successTitle="Request received" successText="We'll email the deck and set up a call within two business days." data-id="element-228" data-mp="4awdp61td4nu" />
      </section>
    </div>;
}